import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.palePurple,
  fontColor: colors.slateGrey,
  textColorDark: colors.slateGrey,
  textColorLight: colors.white
};
export default promoBanner;